import { useRef, useEffect } from "react";
import SVG from "react-inlinesvg";
import Dot from "../../assets/icons/Ellipse.svg";

const wrapperStyles: React.CSSProperties = {
    paddingLeft: "35px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingBottom: "50px",
};

const centerLineStyles: React.CSSProperties = {
    position: "absolute",
    textAlign: "center",
    height: "100%",
    borderLeft: "1px dashed #EF1B1B",
    left: 12.5,
    top: "25px",
};

const dotIconStyles: React.CSSProperties = {
    position: "absolute",
    textAlign: "center",
    top: -12,
    left: -30,
};

const rowStyles: React.CSSProperties = {
    position: "relative",
    marginTop: "30px",
    display: "flex",         // Added flexbox
    alignItems: "center",    // Ensures vertical alignment of icon and text
};

const StepsPoint = ({ steps, textTopMargin }: { steps: string[], textTopMargin?: number }) => {

    const wrapperRef = useRef<HTMLDivElement>(null);
    const centerLineRef = useRef<HTMLDivElement>(null);

    const adjustCenterLineHeight = () => {
        const wrapper = wrapperRef.current;
        const centerLine = centerLineRef.current;

        if (!wrapper || !centerLine) return;


        requestAnimationFrame(() => {
            const icons = document.querySelectorAll(".DotIcon") as NodeListOf<HTMLElement> | null;
            if (icons) {

                if (icons.length === 0) {
                    centerLine.style.height = "0px";
                } else {

                    const lastIcon = icons[icons.length - 1];
                    const iconBottom = lastIcon.offsetTop + lastIcon.offsetHeight;
                    const lastIconBottom = ((lastIcon.closest(".row") as HTMLElement)?.offsetTop || 0) + iconBottom;

                    centerLine.style.height = `${lastIconBottom - 40}px`; // Use 50px as a minimum height
                }
            }
        });
    };

    useEffect(() => {
        const centerLine = centerLineRef.current;
        if (steps.length === 1 && centerLine) {
            centerLine.style.height = "10px"; // A default height for single steps
        }
    }, [steps]);


    useEffect(() => {
        const wrapper = wrapperRef.current;
        setTimeout(adjustCenterLineHeight, 300);

        const resizeObserver = new ResizeObserver(() => {
            adjustCenterLineHeight();
        });

        if (wrapper) {
            resizeObserver.observe(wrapper);
        }

        window.addEventListener("resize", adjustCenterLineHeight);
        window.addEventListener("scroll", adjustCenterLineHeight);

        return () => {
            window.removeEventListener("resize", adjustCenterLineHeight);
            window.removeEventListener("scroll", adjustCenterLineHeight);
            if (wrapper) {
                resizeObserver.unobserve(wrapper);
            }
        };
    }, [steps]);

    return (
        <div className="wrapper" style={wrapperStyles} ref={wrapperRef}>
            <div className="centre-line" style={centerLineStyles} ref={centerLineRef}></div>
            {
                Array.isArray(steps) && steps.length > 0 && steps.every(element => element !== "") ?
                    steps?.map((step: string, index: number) => (
                        <div className="row" style={rowStyles} key={index}>
                            <section>
                                <div className="DotIcon" style={dotIconStyles}><SVG src={Dot} /></div>
                                <p style={{ margin: 0, marginTop: textTopMargin }}>{step}</p>
                            </section>
                        </div>
                    )) : (null)
            }
        </div>
    );
};

export default StepsPoint;
